"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var styled_1 = require("./styled");
var Rainy_1 = __importDefault(require("./Rainy"));
var Snowy_1 = __importDefault(require("./Snowy"));
var Sunny_1 = __importDefault(require("./Sunny"));
var Cloudy_1 = __importDefault(require("./Cloudy"));
var utils_1 = require("../utils");
var cloudyGradient = "linear-gradient(179.08deg, #ADFEFF 0.79%, #FCE5F7 101.36%)";
var sunnyGraient = "linear-gradient(180deg, #5DC4FF 0%, #DCFAF8 97.64%)";
var rainyGradient = "linear-gradient(180deg, #0C176D 0%, #88C4D6 100%)";
var snowyGraident = "linear-gradient(180deg, #476F87 0%, #96BBD8 100%)";
var types = ["snowy", "sunny", "cloudy", "rainy"];
var map = new Map();
var Weather = function (_a) {
    var _b = _a.type, type = _b === void 0 ? "auto" : _b, _c = _a.typeChangeTerm, typeChangeTerm = _c === void 0 ? 10000 : _c, children = _a.children;
    var _d = (0, react_1.useState)(type), refinedType = _d[0], setRefinedType = _d[1];
    var _e = (0, react_1.useState)(false), _ = _e[0], setMount = _e[1];
    var containerRef = (0, react_1.useRef)(null);
    (0, react_2.useEffect)(function () {
        var setIntervalReference;
        if (type === "auto") {
            setIntervalReference = setInterval(function () {
                setRefinedType((0, utils_1.getAutoType)(map, types));
            }, typeChangeTerm);
        }
        return function () {
            clearInterval(setIntervalReference);
        };
    }, []);
    var getBackgroundSrc = function () {
        switch (refinedType) {
            case "cloudy":
                return cloudyGradient;
            case "rainy":
                return rainyGradient;
            case "snowy":
                return snowyGraident;
            default:
                return sunnyGraient;
        }
    };
    var src = getBackgroundSrc();
    var getCanvas = function (children) {
        var _a;
        switch (refinedType) {
            case "rainy":
                return (react_1.default.createElement(Rainy_1.default, { parentHeight: containerRef.current
                        ? "".concat((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight, "px")
                        : "100vh" }, children));
            case "snowy":
                return react_1.default.createElement(Snowy_1.default, null, children);
            case "cloudy":
                return react_1.default.createElement(Cloudy_1.default, null, children);
            case "sunny":
                return react_1.default.createElement(Sunny_1.default, null, children);
            default:
                ;
                react_1.default.createElement(react_1.default.Fragment, null, children);
        }
    };
    (0, react_2.useEffect)(function () {
        setMount(true);
    }, []);
    return (react_1.default.createElement(styled_1.Container, { ref: containerRef, gradient: src }, getCanvas(children)));
};
exports.default = Weather;
